<template>
    <button :type="type" :class="['btn', classButton]">
        <div :class="['btn-container', classContainer]" style="height: 100%;">
            <slot>{{ label }}</slot>
            <div v-if="loading" class="loader-sm"></div>
        </div>
    </button>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'submit'
        },
        label: {
            type: String,
            default: ''
        },
        loading: {
            type: Boolean,
            default: false
        },
        classButton: {
            type: String,
            default: 'btn-success'
        },
        classContainer: {
            type: String,
            default: ''
        }
    }
}
</script>

<style scoped>
.btn-container {
    display: inline-flex;
    gap: 2px;
}
</style>